import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import PlanCards from "./PlanCards";

// The page bundles on the home page, so their prices show without another page. A
// pick opens /bundles with that plan, which logs a guest in and starts buying it.
// Hidden until an admin puts a bundle on sale.
const HomeBundles = () => {
  const history = useHistory();
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    let live = true;
    axios
      .get("/api/bundles/plans")
      .then((res) => {
        if (live && Array.isArray(res.data)) setPlans(res.data);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, []);

  if (plans.length === 0) return null;

  return (
    <section className="home-bundles section" id="bundles">
      <div className="container">
        <div className="home-section-heading has-text-centered">
          <span>ХЭВЛЭЛИЙН БАГЦ</span>
          <h2>Хуудсаа урьдчилж аваад хямд хэвлээрэй</h2>
          <p>
            Бие даалт, курсын ажлаа аль ч киоскоос хэвлэнэ. Багийн багцыг найзуудтайгаа хамт хэрэглээрэй.
          </p>
        </div>
        <PlanCards plans={plans} onBuy={(plan) => history.push("/bundles?plan=" + plan.id)} />
        <p className="home-bundles-more">
          <Link to="/bundles">Багц хэрхэн ажилладаг вэ?</Link>
          {plans.some((plan) => plan.shareable) && (
            <>
              <span aria-hidden="true"> · </span>
              <Link to="/stories">
                <i className="fas fa-images" aria-hidden="true"></i> Багуудын түүх
              </Link>
            </>
          )}
        </p>
      </div>
    </section>
  );
};

export default HomeBundles;
